module.exports = __webpack_public_path__ + "img/menu.1adcd380.svg";